export const normalizeReferenceCode = (code: string): string =>
  code.replace(/[‐‑‒–—−]/g, "-").replace(/\s/g, "").toUpperCase();

export const findMatchingReferenceCodes = <T extends { code: string }>(codes: T[], term: string): T[] => {
  const query = normalizeReferenceCode(term);
  if (!query) return [];
  const exact = codes.filter((row) => normalizeReferenceCode(row.code) === query);
  if (exact.length) return exact;
  return query.length >= 3 ? codes.filter((row) => normalizeReferenceCode(row.code).includes(query)) : [];
};
